import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { map, Observable } from 'rxjs';
import { DossierDocumentType, OperationDocumentType } from 'app/modules/models/dossierDocument.type';

@Injectable({
  providedIn: 'root'
})
export class DossierOperationDocumentsService {
  protected teraApiRoute = environment.TERA_RESOURCE_API;

  constructor(private _httpClient: HttpClient) { }

  getAllByCeeOperationFile(ceeOperationFileId: string): Observable<DossierDocumentType[]> {
    const baseUrl =
      this.teraApiRoute +
      environment.teraApiCatalog.ceeOperationFileDocumentType.controllerRoute +
      environment.teraApiCatalog.ceeOperationFileDocumentType.subRoutes.getAllByCeeOperationFile +
      encodeURIComponent(ceeOperationFileId);

    return this._httpClient.get<OperationDocumentType[]>(baseUrl, this.prepareHeader())
      .pipe(map(items => items.map(item => item.documentType)));
  }

  private prepareHeader(): { headers: HttpHeaders } {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    return { headers: headers };
  }
}
